import { render, staticRenderFns } from "./usappbkpanerver.vue?vue&type=template&id=313389fc&scoped=true&"
import script from "./usappbkpanerver.vue?vue&type=script&lang=js&"
export * from "./usappbkpanerver.vue?vue&type=script&lang=js&"
import style0 from "./usappbkpanerver.vue?vue&type=style&index=0&id=313389fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313389fc",
  null
  
)

export default component.exports